import { ORDER_TYPE } from "../../constants/strings";
import { DetectBrand } from "../../mixins/brandDetector";
import { DetectWC } from "../../mixins/wcDetector";
import { orderTypeHelper } from "./orderTypeHelper";
var isWC = DetectWC.methods.isWC();
export function isStoreSelectionAtCheckout(store) {
  if (
    DetectBrand.methods.isBranded &&
    store.ViewComponentConfigs &&
    store.ViewComponentConfigs.StoreSelectionAtCheckout &&
    store.IsHQ
  ) {
    return true;
  }
  return false;
}

export function parseQueryString() {
  var str = window.location.search;
  if (isWC) {
    str = window.location.hash;
  }
  var objURL = {};

  str.replace(
    new RegExp("([^?=&]+)(=([^&]*))?", "g"),
    function ($0, $1, $2, $3) {
      objURL[$1] = decodeURIComponent($3);
    }
  );
  return objURL;
}
export function getAddressFields(rawData) {
  const addressModel = {
    StreetAddress: "",
    PostalCode: "",
    CityTown: "",
    State: "",
    Phone: "",
    DeliveryInstructions: "",
    Latitude: "",
    Longitude: "",
    Country: "",
    address: "",
  };
  addressModel.Latitude = rawData.geometry.location.lat();
  addressModel.Longitude = rawData.geometry.location.lng();
  addressModel.address = rawData.address;
  for (var i = 0; i < rawData.address_components.length; i++) {
    var addressType = rawData.address_components[i].types[0];
    var val = rawData.address_components[i]["long_name"];

    if (addressType == "locality") {
      addressModel.CityTown = val;
    }

    if (addressType == "administrative_area_level_1") {
      addressModel.State = rawData.address_components[i]["short_name"];
    }

    if (addressType == "country") {
      addressModel.Country = val;
    }

    if (addressType == "street_number" && val) {
      addressModel.StreetAddress += val + " ";
    }
    if (addressType == "route") {
      addressModel.StreetAddress += val;
    }

    if (addressType == "postal_code") {
      addressModel.PostalCode = val;
    }
  }
  return addressModel;
}
export function delay(mili) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, mili);
  });
}
const trimSpace = (str) => {
  if (str) {
    return str.replace(/\s+$/, "");
  }
  return str;
}
export function extraSpaceValidation(obj) {
  const keys = Object.keys(obj);
  if (keys.length > 0) {
    keys.forEach(key => {
      obj[key] = trimSpace(obj[key]);
    })
  }
  return obj;
}

export function validOrderSourceType(orderSourceType) {
  if (orderSourceType === 0) {
    return false;
  } else if (!orderSourceType || (orderSourceType && orderSourceType === 1)) {
    return true;
  }
  return false;
}

export function checkOrderType(orderType) {
  if (!orderType) return true;
  const type = ORDER_TYPE[orderType];
  return type === orderTypeHelper.getOrderType();
}

export function isiOS() {
  const userAgent = navigator.userAgent;
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
